module.exports = __webpack_public_path__ + "static/media/barley.ad7c4cde.jpg";